@for (filter of filters; track filter) {
  <div
    class="badge bg-{{ filter.type || 'primary' }}"
    (click)="onSetFilter(filter)"
    >
    {{ filter.label | translate }}
    <i class="fas fa-angle-right fa-fw"></i>
  </div>
}
